module.exports = __webpack_public_path__ + "static/img/2_1_1.41c84ba3.jpg";